/* eslint-disable no-shadow,no-unused-vars,no-magic-numbers */
export var BlendMode;
(function (BlendMode) {
    BlendMode[BlendMode["OPAQUE"] = 0] = "OPAQUE";
    BlendMode[BlendMode["BLEND"] = 1] = "BLEND";
    BlendMode[BlendMode["MASK"] = 2] = "MASK";
})(BlendMode || (BlendMode = {}));
/**
 * @return {any}
 */
export function toAlphaMode(wasmModule, blendMode) {
    switch (blendMode) {
        case BlendMode.OPAQUE:
            return wasmModule.BlendMode.OPAQUE;
        case BlendMode.BLEND:
            return wasmModule.BlendMode.BLEND;
        case BlendMode.MASK:
            return wasmModule.BlendMode.MASK;
        default: console.log('Wrong argument passed to toAlphaMode()');
    }
}
